
import * as THREE from 'three'
import React, { useRef } from 'react'
import { useFrame } from 'react-three-fiber'
import { useTextureLoader } from 'drei';
import { Texture } from 'three';


type Props = {
  speed: number;
  originalZ: number;
  rotationX: number;
}

export default function Model(props: Props & JSX.IntrinsicElements['group']) {
  const group = useRef<THREE.Group>();
  const meshRef = useRef<THREE.Mesh>();
  const texture = useTextureLoader('/assets/Clouds/clouds.png') as Texture;

  useFrame(() => {
    if (meshRef.current) {
      const position = meshRef.current.position.z;

      if (position + props.originalZ > 1000)
        meshRef.current.position.z = -800 -props.originalZ;
      else
        meshRef.current.position.z += props.speed;
    }
  })


  return (
    <group name="Clouds" {...props}>
      <mesh
        ref={meshRef}
        rotation={[props.rotationX * Math.PI/180, 90 * Math.PI/180, 0]}
        scale={[4, 4, 4]}
      >
        <planeBufferGeometry attach="geometry" args={[20, 20]} />
        <meshStandardMaterial attach="material" map={texture} transparent>
        </meshStandardMaterial>
      </mesh>
    </group>
  )
}
